import { useAuth } from "@clerk/react";
import { useEffect } from "react";
import { applyTierCookies, clearSessionUserId, clearTierCookies, setSessionUserId } from "@/lib/userSession";

/**
 * Login-only entitlement bridge.
 *
 * Used when Clerk billing sync is disabled:
 * - We still require Clerk authentication for protected routes.
 * - Once a user is signed in, we unlock the app by setting:
 *   access_level=pro and plan=Accelerate (top tier), so there is no tier-gating.
 *
 * Note: This relies on Clerk configuration to prevent self-serve signups
 * (invites/admin-created users only). Otherwise any signed-in user could unlock.
 */
export default function ClerkLoginUnlockBridge() {
  const { isLoaded, isSignedIn, user } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;

    if (!isSignedIn) {
      clearTierCookies();
      clearSessionUserId();
      return;
    }

    const email = user?.primaryEmailAddress?.emailAddress || null;
    const userId = user?.id || null;

    // Unlock everything (single paid plan / no tier gating).
    applyTierCookies({ accessLevel: "pro", plan: "Accelerate", email });
    setSessionUserId(userId);
  }, [isLoaded, isSignedIn, user]);

  return null;
}
